import { __rest } from 'tslib';
import React__default from 'react';
import { CommonStyles } from './BaseProps.es.js';
import { styled } from '@teko/styled';

const TYPOGRAPHY_SIZE = {
    heading: [
        {
            fontSize: '48px',
            lineHeight: '64px',
            fontWeight: 'bold',
        },
        {
            fontSize: '40px',
            lineHeight: '56px',
            fontWeight: 'medium',
        },
        {
            fontSize: '36px',
            lineHeight: '48px',
            fontWeight: 'medium',
        },
        {
            fontSize: '32px',
            lineHeight: '40px',
            fontWeight: 'bold',
        },
    ],
    title: [
        {
            fontSize: '24px',
            lineHeight: '32px',
            fontWeight: 'bold',
        },
        {
            fontSize: '20px',
            lineHeight: '28px',
            fontWeight: 'bold',
        },
    ],
    subtitle: [
        {
            fontSize: '15px',
            lineHeight: '24px',
            fontWeight: 'bold',
        },
        {
            fontSize: '15px',
            lineHeight: '24px',
            fontWeight: 'medium',
        },
        {
            fontSize: '13px',
            lineHeight: '24px',
            fontWeight: 'bold',
        },
        {
            fontSize: '13px',
            lineHeight: '24px',
            fontWeight: 'medium',
        },
    ],
    body: [
        {
            fontSize: '13px',
            lineHeight: '18px',
            fontWeight: 'regular',
        },
        {
            fontSize: '13px',
            lineHeight: '18px',
            fontWeight: 'medium',
        },
    ],
    caption: [
        {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 'regular',
        },
        {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 'medium',
        },
        {
            fontSize: '10px',
            lineHeight: '16px',
            fontWeight: 'medium',
        },
    ],
};
const FONT_WEIGHT_MAP = {
    bold: 700,
    medium: 500,
    regular: 400,
};
const getTypographySize = (type, level = 1, attr) => {
    const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
    return tagAttrs[attr];
};

const StyledTypography = styled.div `
  margin: 0;
  padding: 0;
  ${CommonStyles}
  color: ${(p) => p.theme.colors[p.color] || p.color || 'inherit'};
  font-weight: ${(p) => (p.weight
    ? FONT_WEIGHT_MAP[p.weight]
    : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, 'fontWeight')]) ||
    500};
  text-decoration: ${(p) => p.decoration || 'unset'};
  font-size: ${(p) => getTypographySize(p.type, p.level, 'fontSize')};
  line-height: ${(p) => getTypographySize(p.type, p.level, 'lineHeight')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || 'unset'};
  max-width: ${(p) => (p.maxWidth ? `${p.maxWidth}px` : 'unset')};
  min-width: ${(p) => (p.minWidth ? `${p.minWidth}px` : 'unset')};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor
    ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }`
    : ''};
`;
const Heading = (_a) => {
    var { level = 4 } = _a, props = __rest(_a, ["level"]);
    return (React__default.createElement(StyledTypography, Object.assign({ type: "heading", as: `h${level}`, level: level }, props)));
};
const Title = (_a) => {
    var { level = 2 } = _a, props = __rest(_a, ["level"]);
    return (React__default.createElement(StyledTypography, Object.assign({ type: "title", level: level }, props)));
};
const SubTitle = (_a) => {
    var { level = 4 } = _a, props = __rest(_a, ["level"]);
    return (React__default.createElement(StyledTypography, Object.assign({ type: "subtitle", level: level }, props)));
};
const Body = (_a) => {
    var { level = 2 } = _a, props = __rest(_a, ["level"]);
    return (React__default.createElement(StyledTypography, Object.assign({ type: "body", level: level }, props)));
};
const Caption = (_a) => {
    var { level = 3 } = _a, props = __rest(_a, ["level"]);
    return (React__default.createElement(StyledTypography, Object.assign({ type: "caption", level: level }, props)));
};

export { Body, Caption, Heading, SubTitle, Title };
